import Client from 'shopify-buy';

export default Client.buildClient({
  storefrontAccessToken: '1fbd3cd95db7924bc4e00261ab81307c',
  domain: 'blenderseyewear-com.myshopify.com'
});
